import React from "react";

import RichText from "./RichText";
interface QuestionAndAnswerProps {
  data: {
    question: string;
    answer: string;
  };
}

const QuestionAndAnswer = (props: QuestionAndAnswerProps) => {
  const { data } = props;
  return (
    <details className="accordion">
      <summary className="summary">
        {data.question && <RichText data={data.question} />}
      </summary>
      {data.answer && <RichText data={data.answer} />}
    </details>
  );
};

export default QuestionAndAnswer;
